import { configureStore } from '@reduxjs/toolkit';
import modalReducer from './features/modal/modal.slice';
import authReducer from './features/auth/auth.slice';
import apiTokenReducer from './features/apitoken/apitoken.slice';
import postReducer from './features/post/post.slice';

export const store = configureStore({
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: false,
    });
  },
  reducer: {
    auth: authReducer,
    modal: modalReducer,
    apiToken: apiTokenReducer,
    post: postReducer,
  },
});
